import config from 'config';
import { http_client } from './api';

const getList = async (status, query) => {
  return http_client.get(config.apiUrl + 'student/list/' + status, query).then((response) => {
    return response.data;
  });
};

const create = async (data) => {
  return http_client.post(config.apiUrl + 'student', data).then((response) => {
    return response.data;
  });
};

const read = async (id) => {
  return http_client.get(config.apiUrl + 'student/' + id).then((response) => {
    return response.data;
  });
};

const update = async (id, data) => {
  return http_client.patch(config.apiUrl + 'student/' + id, data).then((response) => {
    return response.data;
  });
};

const updateRef = async (id, data) => {
  return http_client.post(config.apiUrl + 'student/' + id + '/ref', data).then((response) => {
    return response.data;
  });
};

const del = async (id) => {
  return http_client.delete(config.apiUrl + 'student/' + id).then((response) => {
    return response.data;
  });
};

const addMapel = async (id, mapelID) => {
  return http_client.post(config.apiUrl + 'student/' + id + '/mapel/' + mapelID).then((response) => {
    return response.data;
  });
};

const delMapel = async (id, mapelID) => {
  return http_client.delete(config.apiUrl + 'student/' + id + '/mapel/' + mapelID).then((response) => {
    return response.data;
  });
};

const changeStatus = async (id, data) => {
  return http_client.post(config.apiUrl + 'student/status/' + id, data).then((response) => {
    return response.data;
  });
};

const updatePhoto = async (id, data) => {
  return http_client.post(config.apiUrl + 'student/photo/' + id, data).then((response) => {
    return response.data;
  });
};

const deletePhoto = async (id) => {
  return http_client.delete(config.apiUrl + 'student/photo/' + id).then((response) => {
    return response.data;
  });
};

const verifyStudent = async (id) => {
  return http_client.post(config.apiUrl + 'student/verify/' + id).then((response) => {
    return response.data;
  });
};

const getCode = async (page = null, perPage = null, sort = null, orderBy = null, search = null) => {
  return http_client
    .get(
      config.apiUrl +
        'student/code?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const getCodeHistory = async (id) => {
  return http_client.get(config.apiUrl + 'student/code/' + id).then((response) => {
    return response.data;
  });
};

const getPayment = async (id, page = null, perPage = null, sort = null, orderBy = null) => {
  return http_client
    .get(
      config.apiUrl +
        'student/' +
        id +
        '/payment?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const storePayment = async (id) => {
  return http_client.post(config.apiUrl + 'student/' + id + '/payment').then((response) => {
    return response.data;
  });
};

const storeRefferal = async (id, data) => {
  return http_client.post(config.apiUrl + 'student/' + id + '/referral', data).then((response) => {
    return response.data;
  });
};

const deleteRefferal = async (id, referid) => {
  return http_client.delete(config.apiUrl + 'student/' + id + '/referral/' + referid).then((response) => {
    return response.data;
  });
};

const changePassword = async (id, data) => {
  return http_client.post(config.apiUrl + 'student/' + id + '/password', data).then((response) => {
    return response.data;
  });
};

const gradeUpAll = async () => {
  return http_client.post(config.apiUrl + 'student/grade-up').then((response) => {
    return response.data;
  });
};

const gradeUp = async (id, data) => {
  return http_client.post(config.apiUrl + 'student/' + id + '/grade-up', data).then((response) => {
    return response.data;
  });
};

const processGradeUp = async (id, data) => {
  return http_client.post(config.apiUrl + 'student/' + id + '/process-grade-up', data).then((response) => {
    return response.data;
  });
};

const activateAllGradeUp = async () => {
  return http_client.post(config.apiUrl + 'student/activate-all-grade-up').then((response) => {
    return response.data;
  });
};

const movePendingToGradeUp = async () => {
  return http_client.post(config.apiUrl + 'student/move-pending-to-grade-up').then((response) => {
    return response.data;
  });
};

const getBirthdayStudent = async (query) => {
  return http_client.get(config.apiUrl + 'student/birthday-student', query).then((response) => {
    return response.data;
  });
};

const exportDataStudent = async (query) => {
  try {
    const today = new Date();
    const day = today.getDate().toString().padStart(2, '0');
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const year = today.getFullYear().toString();

    const response = await http_client.getFile(config.apiUrl + 'student/export', query);

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `student-${day}-${month}-${year}.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error exporting student data:', error);
  }
};

const exportBirthdayStudent = async (query) => {
  try {
    const today = new Date();
    const day = today.getDate().toString().padStart(2, '0');
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const year = today.getFullYear().toString();

    const response = await http_client.getFile(config.apiUrl + 'student/birthday-student/export', query);

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `student-birthday-${day}-${month}-${year}.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error exporting student data:', error);
  } 
}

const StudentService = {
  getList,
  create,
  read,
  update,
  updateRef,
  del,
  addMapel,
  delMapel,
  changeStatus,
  updatePhoto,
  deletePhoto,
  verifyStudent,
  getCode,
  getCodeHistory,
  getPayment,
  storePayment,
  storeRefferal,
  deleteRefferal,
  changePassword,
  gradeUp,
  gradeUpAll,
  processGradeUp,
  activateAllGradeUp,
  movePendingToGradeUp,
  exportDataStudent,
  getBirthdayStudent,
  exportBirthdayStudent
};

export default StudentService;
